import { Box, Typography } from '@mui/material'
import { PrintECGLead } from './components/PrintECGLead'
import { useECGHighlight } from './hooks/useECGHighlight'
import {
  ECG_LEAD_CHANNELS,
  RHYTHM_STRIP_HEIGHT,
  STANDARD_LEAD_HEIGHT
} from './constants/ecgLayout'
import { IExamResponse } from 'types/exam/types'

interface PrintECGExamProps {
  exameData: IExamResponse
}

/**
 * Componente de ECG otimizado para impressão
 * Sem modal, cliques ou hover
 */
export const PrintECGExam = ({ exameData }: PrintECGExamProps) => {
  const { isHighlighted } = useECGHighlight(exameData)
  const ecgRawData = exameData.ecg_raw_data

  const renderLeadRow = (leadProperties: string[], height: number) => {
    if (!ecgRawData) return null

    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 0,
          m: 0,
          backgroundColor: '#ffffff'
        }}
      >
        {leadProperties.map(leadProperty => {
          const leadData = ecgRawData[leadProperty as keyof typeof ecgRawData]
          const values = Array.isArray(leadData) ? leadData : []
          const displayName = leadProperty.replaceAll('lead_', '').toUpperCase()

          return (
            <PrintECGLead
              key={leadProperty}
              name={displayName}
              data={values}
              highlight={isHighlighted(displayName)}
              height={height}
            />
          )
        })}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#ffffff',
        padding: 0,
        pageBreakInside: 'avoid'
      }}
    >
      <Typography
        variant='subtitle2'
        sx={{ mb: 0.5, fontWeight: 'bold', fontSize: '0.875rem' }}
      >
        Eletrocardiograma - 12 Derivações
      </Typography>

      {/* Canal 1: I, aVR, V1, V4 */}
      {renderLeadRow(ECG_LEAD_CHANNELS.CHANNEL_1, STANDARD_LEAD_HEIGHT)}

      {/* Canal 2: II, aVL, V2, V5 */}
      {renderLeadRow(ECG_LEAD_CHANNELS.CHANNEL_2, STANDARD_LEAD_HEIGHT)}

      {/* Canal 3: III, aVF, V3, V6 */}
      {renderLeadRow(ECG_LEAD_CHANNELS.CHANNEL_3, STANDARD_LEAD_HEIGHT)}

      {/* Canal 4: Faixa de Ritmo (II longo) */}
      <Box sx={{ backgroundColor: '#ffffff' }}>
        {ecgRawData &&
          ECG_LEAD_CHANNELS.RHYTHM.map(leadProperty => {
            const leadData = ecgRawData[leadProperty as keyof typeof ecgRawData]
            const values = Array.isArray(leadData) ? leadData : []
            const displayName = leadProperty
              .replaceAll('lead_', '')
              .toUpperCase()

            return (
              <PrintECGLead
                key={leadProperty}
                name={displayName}
                data={values}
                highlight={isHighlighted(displayName)}
                height={RHYTHM_STRIP_HEIGHT}
                isRhythmStrip={true}
              />
            )
          })}
      </Box>
    </Box>
  )
}

export default PrintECGExam
